import React from 'react';
import {
    Row, Col,
    PanelGroup, Panel,
    Nav, NavItem, Tab,
} from 'react-bootstrap';
import Card from '../../components/Card/Card.jsx';

class QuestionPanels extends React.Component {
  // constructor(props) {
  //   super(props);
  // }

  generatePanels(array) {
    const htmlArray = [];
    array.forEach((item, index) => {
      htmlArray.push(
        <Panel
            key={index}
            collapsible
            header={
                <div>
                    {item.pregunta}
                    <b className="caret"></b>
                </div>
            }
            eventKey="1">
            {item.respuesta}
        </Panel>
      );
    });
    const tabArray = [];
    const navArray = [];
    this.chunk(htmlArray, 10).forEach((chunk, index) => {
      tabArray.push(
        <Tab.Pane eventKey={index+1} key={index+1}>
          <div>
            {chunk}
          </div>
        </Tab.Pane>
      );
      navArray.push(
        <NavItem eventKey={index+1} key={index+1}>
            {index+1}
        </NavItem>
      )
    });
    return (
      <Tab.Container defaultActiveKey={1} id="questions" >
          <Row className="clearfix">
              <Col sm={12}>
                  <Nav bsStyle="tabs">
                      {navArray}
                  </Nav>
              </Col>
              <Col sm={12}>
                  <Tab.Content animation>
                      {tabArray}
                  </Tab.Content>
              </Col>
          </Row>
      </Tab.Container>
    );
  }

  chunk (arr, len) {
    var chunks = [],
        i = 0,
        n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, i += len));
    }
    return chunks;
  }

  render() {
    return (
      <Card
          title={this.props.proyectInfo.proyecto}
          subTitle={this.props.proyectInfo.responsable}
          category={this.props.proyectInfo.sector}
          content={
            <PanelGroup id="accordion" ref="panels">
              {this.generatePanels(this.props.proyectInfo.encuesta)}
            </PanelGroup>
          }
      />
    );
  }
}

export default QuestionPanels;



// WEBPACK FOOTER //
// ./src/views/Incubation/QuestionPanels.jsx